import * as React from 'react';
/**
 *
 * Original name: replace image
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=2916%3A1053
 *
 */
export const ReplaceImageLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M14.759 4.995 18.251 5H19v7h-1.5V6.5l-2.736-.005 1.027 1.068-1.082 1.04-2.75-2.86 2.75-2.86 1.082 1.04-1.032 1.072ZM9.236 17.506 8.209 16.44l1.082-1.04 2.75 2.86-2.75 2.86-1.082-1.04 1.032-1.073-3.492-.005H5V12h1.5v5.503l2.736.003Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 5H5v5.5h5.5V5ZM9 9H6.5V6.5H9V9Zm10 10h-5.5v-5.5H19V19Zm-1.5-4H15v2.5h2.5V15Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
